document.addEventListener('turbolinks:load', () => {
    if($('body').data('environment') == 'staging'){
        dispatchDevNotice(I18n.t('dev_server_notification.title'), I18n.t('dev_server_notification.message'))
    }
})